import { sansSerifStyles } from "@pathwright/blocks/src/ui/typography"
import { Content } from "@pathwright/ui/src/components/content/Content"
import styled from "styled-components"
import { isEmptyHTML } from "../../../utils"

export const Container = styled.div`
  font-style: italic;
  color: #999;
  text-align: center;
  /* margin: 15px 0px; */
  padding: 15px 0px;

  /* styles to apply quill editor content */
  .ql-editor,
  .BlockText {
    text-align: center;
    ${sansSerifStyles()}
  }

  /* Fixes the issue where Firefox removes final spaces */
  .ql-editor p {
    white-space: pre-wrap;
  }
`

export const CaptionText = (props) => (
  <Container>
    <Content.Text {...props} />
  </Container>
)

const Caption = ({ caption }) => {
  if (isEmptyHTML(caption.html)) return null

  return (
    <Content.Container>
      <CaptionText dangerouslySetInnerHTML={{ __html: caption.html }} />
    </Content.Container>
  )
}

export default Caption
